import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/supplier/$supplierId/_layout/_index/',
)({
  component: () => null,
});
